<script>
  /**
   * 運転日報 作成ボタン
   */
  import { DRIVE_REPORT_SCHEME } from '../../scheme'

  import FireDocForm from './FireDocForm.svelte'

  export let reportRef // これから作成する ドキュメントへの リファレンス
  export let date // 日付
  export let reporterName // 報告者名

  let fireDocForm // コンポーネント保持用
</script>

<!-- 新規作成ボタン -->
<button
  class="button"
  data-testid="driveReportCreateButton"
  on:click={() =>
    fireDocForm.open({
      ref: reportRef,
      date,
      reporterName,
    })}>運転日報を作成する</button
>

<!-- フォームを仕込む -->
<FireDocForm
  name="driveReportCreator"
  title="運転日報"
  scheme={DRIVE_REPORT_SCHEME}
  bind:this={fireDocForm}
/>
